import { render, staticRenderFns } from "./BusinessDeliveryBilling.vue?vue&type=template&id=69ed1bfe&"
import script from "./BusinessDeliveryBilling.vue?vue&type=script&lang=js&"
export * from "./BusinessDeliveryBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports